module.exports = __webpack_public_path__ + "files/32b3bc76e4343273f2bcbe8ebb26aaa9.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/PT-Sans-regular.eot
// module id = 323
// module chunks = 60